export const QueryReportType = {
  transactions: {
    text: 'Dealer Purchase Receipt Report Summary',
    value: 'TRANSACTIONS'
  },
  species: {
    text: 'Dealer Report Summary of Species Purchased',
    value: 'SPECIES'
  },
  industry: {
    text: 'Industry Dealer Report Summary',
    value: 'INDUSTRY'
  }
};


export class QueryReportTypeClass {
  text: string;
  value: string;

  constructor(text: string, value: string) {
    this.text = text;
    this.value = value;
  }
}
